<div class="admin_card add_student">
  <div class="subscribe_form student-addition">

    <div class="add_student-form-main">
   <div class="row justify-content-center">
   <div class="col-sm-11">
   <form  [formGroup]="form" (submit)="onSubmit($event)"
   class="parents_registration_form-main student-1 add_student-form">


<div class="row justify-content-center">
<div class="col-md-12" 
style="display: flex; flex-direction: row; justify-content: center; align-items: center;">

<ng-container *ngFor="let field of fields"  mrsoftappsDynamicFlatField [field]="field" [group]="form">

</ng-container>
<div style="display: flex; flex-direction: row; justify-content: center; align-items: center;" class="mt-3">

<button class="btn btn-primary" type="submit">
Submit
</button>
</div>

</div>
</div>
</form>
   </div>
   </div>
    </div>
  </div>
</div>
